import Telloport from './svg/telloport.svg';

export const CORPORATE_ICONS = {
    TELLOPORT: Telloport
};
